export default {
  priv: 'manage',
  overviewTitle: 'Historiek',
  detailTitle: 'Historiek',
  deleteTitle: 'deze Historiek',
  url: '/inspectionevents',
  apiUrl: '/inspectionevents/',
  sortBy: ['timestamp'],
  sortDesc: [true],
  deletable: false,
  editable: false,
  filterName: 'inspectionevents',
  quickFilter: {
    text: 'Zoek op inspection_id',
    value: 'inspection_id',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Periode van', value: 'timestamp_date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Periode tot', value: 'timestamp_date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Gebruiker', value: 'user_id', type: 'optionList', optionListName: 'users', optionListParams: {}, columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Type', value: 'inspectioneventtype_id', type: 'optionList', optionListName: 'inspectioneventtypes', optionListParams: {}, columns: 2, labelCols: 3, inputCols: 9},
    {text: 'Keuring', value: 'inspection_id', type: 'optionList', optionListName: 'inspections', optionListParams: {}, columns: 2, labelCols: 3, inputCols: 9}
  ],
  newRecord: {
  },
  // isReadOnlyOverview: true,
  customEditable(item) {
    return false;
  },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Tijd', value: 'timestamp', link: '/inspectionevents/{id}', width: '10%', filter: 'timestamp'},
    {text: 'Gebruiker', value: 'user_full_name', width: '10%'},
    {text: 'Keuring', value: 'inspection_name', link: '/tc/inspections/{inspection_id}', width: '10%'},
    {text: 'Type', value: 'inspectioneventtype_name_nl', width: '10%'},
    {text: 'Status', value: 'processstate_name_nl', width: '10%'},
    {text: 'Comments', value: 'comments', width: '50%'}
  ]
};
